import script from "./ManagementPainPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagementPainPoints.vue?vue&type=script&setup=true&lang=js"

import "./ManagementPainPoints.vue?vue&type=style&index=0&id=13553c0d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13553c0d"]])

export default __exports__